import { z } from "zod/v4"
import { DocumentSnapshotLike } from "../firestore"
import { UserDenormalizedWithoutLook } from "./user"
import { PowerDenormalized } from "./power"
import { LivePowerId, LivePowerIdSchema, PowerIdSchema } from "../id"
import { CreatedAt, UpdatedAt } from "./system"
import { CoinSpent } from "./live-power-history"
import { SpaceDenormalized } from "./space"
import { LiveDenormalized } from "./live"

export { LivePowerId }

export const LivePowerDenormalizedCommon = z.object({
  power: PowerDenormalized,
  user: UserDenormalizedWithoutLook,
})

export type LivePowerDenormalizedCommon = z.infer<typeof LivePowerDenormalizedCommon>

export const LivePowerDenormalized = z.intersection(
  LivePowerDenormalizedCommon,
  z.object({
    id: LivePowerIdSchema,
    created_at: CreatedAt,
  }),
)

export type LivePowerDenormalized = z.infer<typeof LivePowerDenormalized>

export const LivePowerDocumentBody = z.intersection(
  LivePowerDenormalizedCommon,
  z.object({
    space: SpaceDenormalized.optional().describe("パワーが送信されたスペースの非正規化情報。"),
    live: LiveDenormalized.optional().describe("パワーが送信されたライブの非正規化情報。"),
    nonce: z.string().optional().describe("コイントランザクションのnonce。coin-transactions との紐付けに使用する。"),
    platform: z.string().optional().describe("パワー送信時のプラットフォーム (ios/android)。"),
    coin_spent: CoinSpent.optional().describe("コイン消費の内訳（有償・無償）。"),
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  }),
)

export const LivePowerDocument = z.intersection(
  LivePowerDocumentBody,
  z.object({
    id: LivePowerIdSchema,
  })
)

export type LivePowerDocument = z.infer<typeof LivePowerDocument>

export class LivePowers {

  static toDocumentData(doc: LivePowerDocument): object {
    return {
      ...doc,
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): LivePowerDocument | null {
    if (!doc) {
      return null
    }

    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: LivePowerId(doc.id),
      power: data["power"],
      user: data["user"],
      space: data["space"],
      live: data["live"],
      nonce: data["nonce"],
      platform: data["platform"],
      coin_spent: data["coin_spent"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}

export const PostLivePowerRequest = z.object({
  powerId: PowerIdSchema,
})

export type PostLivePowerRequest = z.infer<typeof PostLivePowerRequest>
